import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { respond } from "../../styles/responsive";
import { track } from "../../util/analytics";
import Spinner from "./Spinner";
import { formApiBaseUrl } from "../../util/baseUrls";
import { HubspotForm } from "./HubspotForm";
const SINGLE_COLUMN = "768px";
const Wrapper = styled.div`
    width: 100%;
    max-width: 1800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    ${respond(37, 40, "px", "paddingBottom")};

    @media screen and (min-width: 1080px) {
        align-items: flex-start;
        flex-direction: row;
    }
`;
const Title = styled.h2`
    font-family: Plaak, sans-serif;
    line-height: 0.92;
    letter-spacing: 0.02em;
    font-weight: 700;
    text-transform: uppercase;
    ${respond(52, 80)};
    margin-bottom: 40px;
    text-align: center;
    flex: 1;

    @media screen and (min-width: ${SINGLE_COLUMN}) {
        text-align: left;
        width: 606px;
    }
    @media screen and (min-width: 1080px) {
        margin-bottom: 0;
        width: auto;
        text-align: left;
    }
`;
const FormDetailsContainer = styled.div`
    width: 100%;
    position: relative;

    @media screen and (min-width: ${SINGLE_COLUMN}) {
        width: 606px;
    }
    @media screen and (min-width: 1080px) {
        margin-left: 137px;
        width: 638px;
    }
`;
const SuccessMessage = styled.div`
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;

    display: ${({ show }) => (show ? "flex" : "none")};
    align-items: center;
    justify-content: center;
    letter-spacing: 0.065em;
    ${respond(22, 50, "px", "paddingLeft")};
    ${respond(22, 50, "px", "paddingRight")};
`;
const SuccessMessageText = styled.div`
    text-align: center;
    text-transform: uppercase;
    font-family: FoundryGridnik, sans-serif;
    font-weight: 500;
    ${respond(18, 20)};
    line-height: 1.18;
`;
export const Terms = styled.div`
    visibility: ${({ show }) => (show ? "visible" : "hidden")};
    margin-top: 24px;
    font-size: 14px;
    line-height: 1.25;
    a {
        color: white;
        &:visited {
            color: white;
        }
    }
    text-align: center;
    @media screen and (min-width: ${SINGLE_COLUMN}) {
        text-align: left;
    }
`;

const Form = () => {
    const formId = "385f245c-4854-4223-b110-0c2bf0f03e77";
    const [formData, setFormData] = useState(null);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const onSubmit = () => {
        track({ event: "SubscribeFormSubmitted" });
        setShowSuccessMessage(true);
    };
    // const form = useHubspotForm(formData, { onSubmit });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch(
                    `${formApiBaseUrl}/api/hubspot-form/${formId}/fields`
                );
                if (res.ok) {
                    const formData = await res.json();
                    setFormData(formData);
                } else {
                    console.error("Error fetching form data", res.statusText);
                }
            } catch (error) {
                console.error("Error fetching form data", error);
            }
        };
        fetchData();
    }, [formId]);

    return (
        <Wrapper>
            <Title>Sign up for the latest news & insights</Title>
            <FormDetailsContainer>
                <SuccessMessage show={showSuccessMessage}>
                    <SuccessMessageText>
                        Thank you! Please check your email to confirm your
                        subscription.
                    </SuccessMessageText>
                </SuccessMessage>
                {!formData && <Spinner visible={!formData} />}
                {formData && !showSuccessMessage && (
                    <HubspotForm formData={formData} onSubmit={onSubmit} />
                )}
                <Terms show={!showSuccessMessage && formData}>
                    Your e-mail address is used to send you newsletters and
                    marketing information on L’Atelier. You can unsubscribe at
                    any time by using the unsubscribe link in our emails. More
                    information about the management of your personal data and
                    your rights can be found in our{" "}
                    <a href={"/data-protection-notice"} target={"_blank"}>
                        Data Protection Notice
                    </a>
                    .
                </Terms>
            </FormDetailsContainer>
        </Wrapper>
    );
};

export default Form;
